
// function to use regular expression to extract the numbers at the end of a string like this "How-to-Analyze-Your-Best-SEO-6754"
export function extractNumbersFromString(str){
    if(str){
        // Match digits at the end of the string
        const match = str.match(/\d+$/);
        // Return the matched number or null if not found
        return match ? match[0] : null;
    }else{
        return 0;
    }
};


// Builds the URL slug for a blog post -- a readable, title-based slug ending in the post's real
// numeric id, since blog details pages resolve the post via extractNumbersFromString() on the slug.
export function blogPostSlug(post){
    if(!post) return "";
    const titleSlug = String(post.title)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
    return `${titleSlug}-${post.id}`;
};


// Shared filter used by both the blog hero (for a live result count) and the blog grid (for what
// actually renders), so the two never drift out of sync with each other.
export function filterBlogPosts(posts, search, activeTag){
    const normalizedSearch = (search || "").trim().toLowerCase();
    return posts.filter((post) => {
        const matchesTag = !activeTag || activeTag === "All" || post.tag.some((t) => t.tag === activeTag);
        if(!matchesTag) return false;
        if(!normalizedSearch) return true;
        return (
            post.title.toLowerCase().includes(normalizedSearch) ||
            post.desc.toLowerCase().includes(normalizedSearch) ||
            post.tag.some((t) => t.tag.toLowerCase().includes(normalizedSearch))
        );
    });
};

